import { atom } from "jotai";

// Current tenant ID - writable atom that can be accessed outside React
// Used by middlewares via getDefaultStore() and components via useAtom()
export const currentTenantIdAtom = atom<string | null>(null);

const RESERVED_SEGMENTS = ["processes"];

/**
 * Extract tenant ID from a given pathname
 * Used by tenant-context-middleware to set the current tenant context
 */
export const getTenantIdFromPathname = (pathname: string): string | null => {
  // Match /t/{tenantId}/... or /t/{tenantId}
  const match = pathname.match(/^\/t\/([^/?#]+)/);

  // Exclude reserved route segments that are not tenant IDs
  if (match && !RESERVED_SEGMENTS.includes(match[1])) {
    return match[1];
  }

  return null;
};
